import React from "react";
import { Box, Card, CardContent, Typography, List, ListItem, ListItemText, Button } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

interface FileItem {
  fileName: string;
  filePath: string;
}

interface FileViewProps {
  files: FileItem[];
  sasUrls?: { [key: string]: string };
  isLoading?: boolean;
}

const FileView: React.FC<FileViewProps> = ({ files, sasUrls = {}, isLoading }) => {
  console.log("sasUrls-------->", sasUrls);
  return (
    <Box sx={{ padding: 4, maxWidth: "100%", margin: "0 auto" }}>
      <Card
        sx={{
          backgroundColor: "#f5faff", // Light blue tint for a professional look
          border: "1px solid #d0e4ff", // Soft blue border
          borderRadius: "6px",
          boxShadow: "none",
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#0d47a1" }}>
            Files
          </Typography>
          <List>
            {files.map((file, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#ffffff", // Clean white background for contrast
                  borderRadius: "4px",
                  padding: "8px 12px",
                  marginBottom: "8px",
                  // boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <InsertDriveFileIcon sx={{ color: "#1565c0", marginRight: 1 }} />
                  <ListItemText primary={file.fileName} sx={{ fontWeight: 500, color: "#333" }} />
                </Box>
                <Box>
                  <Button
                    href={sasUrls?.[file.fileName] || file.filePath}
                    download
                    size="small"
                    sx={{ color: "#1565c0", textTransform: "none" }}
                  >
                    Download
                  </Button>
                  <Button
                    href={sasUrls?.[file.fileName] || file.filePath}
                    target="_blank"
                    size="small"
                    sx={{ marginLeft: 1, color: "#0d47a1", textTransform: "none" }}
                  >
                    View
                  </Button>
                </Box>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FileView;